import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CmsLinkComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-shared-link',
    templateUrl: './shared-link.component.html',
    styleUrl: './shared-link.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedLinkComponent {

  // Expose the CMS component data as an observable so the template can consume
  // it via `| async`. Prior implementation stored the value in a plain field
  // from inside `subscribe()`, which combined with OnPush meant that late CMS
  // emissions (e.g. header/footer links loaded after the initial change
  // detection cycle) never re-rendered the view.
  public componentData$: Observable<CmsLinkComponent> = this.component.data$;

  constructor(public component: CmsComponentData<CmsLinkComponent>) { }
}
